import http from 'hub-http/clients/apiClient';
import { PRODUCT_INVENTORY } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const ENDPOINT = 'monetization/v3/product/inventory';
export const getProductInventory = () => {
  const earlyRequest = getEarlyRequesterResult(PRODUCT_INVENTORY);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};